import React, { Component } from "react";

export default class FullStackImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="web-developer-illustration"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 960 758.455"
      >
        <title>Web Development</title>
        <g transform="translate(-573.443 -234.598)">
          <path
            d="M3.7-11.338l22.447,3.2,1.534,29.079L0,30.181Z"
            transform="translate(820.572 936.044)"
            fill="#ffb8b8"
          />
          <path
            d="M415.968,626.548H474.3a33.642,33.642,0,0,0,14.493-3.3l10.754-5.168a6.458,6.458,0,0,0-1.075-12.044L476.288,599.9l-37.958-19.949-.029.144c-.71,3.594-1.809,9.025-1.946,9.355-3.892,4.46-7.891,6.514-11.883,6.108-6.965-.706-11.6-8.749-11.642-8.831l-.034-.062-.071.008a4.62,4.62,0,0,0-3.585,1.955c-1.59,2.4-.62,6.086-.46,6.643-1.9,1.861-2.761,12.26-2.823,13.1-2.752,2.916-4.059,5.72-3.893,8.333a8.972,8.972,0,0,0,3.763,6.306,16.291,16.291,0,0,0,10.237,3.545Z"
            transform="translate(409.287 364.637)"
            fill={theme.dark}
          />
          <path
            d="M2.758-5.3,27.522-3.694V28.722H0Z"
            transform="translate(790.951 937.503)"
            fill="#ffb8b8"
          />
          <path
            d="M21.848,112.3l4.009-28.429a43.86,43.86,0,1,1,34.759.542L63.578,112.3Z"
            transform="translate(667.867 440.346)"
            fill="#ffb8b8"
          />
          <g transform="translate(957.48 234.598)">
            <path
              d="M0,0H575.717V263.254a9.934,9.934,0,0,1-9.934,9.934H9.934A9.934,9.934,0,0,1,0,263.254Z"
              transform="translate(0.245 15.785)"
              fill={theme.secondaryText}
            />
            <path
              d="M0,0H542.793V227.929H0Z"
              transform="translate(16.708 39.21)"
              fill={theme.body}
            />
            <path
              d="M9.934,0h555.85a9.934,9.934,0,0,1,9.934,9.934V24.458H0V9.934A9.934,9.934,0,0,1,9.934,0Z"
              fill={theme.imageHighlight}
            />
            <path
              d="M4.533,0A4.533,4.533,0,1,1,0,4.533,4.533,4.533,0,0,1,4.533,0Z"
              transform="translate(13.642 7.366)"
              fill={theme.body}
            />
            <path
              d="M4.533,0A4.533,4.533,0,1,1,0,4.533,4.533,4.533,0,0,1,4.533,0Z"
              transform="translate(30.849 7.366)"
              fill={theme.body}
            />
            <path
              d="M4.533,0A4.533,4.533,0,1,1,0,4.533,4.533,4.533,0,0,1,4.533,0Z"
              transform="translate(48.056 7.366)"
              fill={theme.body}
            />
            <path
              d="M9.934,0H80.31a9.934,9.934,0,0,1,9.934,9.934v134.3a9.934,9.934,0,0,1-9.934,9.934H9.934A9.934,9.934,0,0,1,0,144.233V9.934A9.934,9.934,0,0,1,9.934,0Z"
              transform="translate(341.471 76.092)"
              fill={theme.secondaryText}
            />
            <path
              d="M9.934,0H172.092a9.934,9.934,0,0,1,9.934,9.934V32.5a9.934,9.934,0,0,1-9.934,9.934H9.934A9.934,9.934,0,0,1,0,32.5V9.934A9.934,9.934,0,0,1,9.934,0Z"
              transform="translate(144.493 76.09)"
              fill={theme.imageHighlight}
            />
            <path
              d="M9.934,0H172.092a9.934,9.934,0,0,1,9.934,9.934V35.725a9.934,9.934,0,0,1-9.934,9.934H9.934A9.934,9.934,0,0,1,0,35.725V9.934A9.934,9.934,0,0,1,9.934,0Z"
              transform="translate(144.493 130.344)"
              fill={theme.secondaryText}
            />
            <path
              d="M9.934,0H172.092a9.934,9.934,0,0,1,9.934,9.934V32.5a9.934,9.934,0,0,1-9.934,9.934H9.934A9.934,9.934,0,0,1,0,32.5V9.934A9.934,9.934,0,0,1,9.934,0Z"
              transform="translate(144.493 187.822)"
              fill={theme.secondaryText}
            />
          </g>
          <path
            d="M463.283,535.484a22.186,22.186,0,0,0-24.574-22.18,21.366,21.366,0,0,0-2.915.537l-75.08-64.356L365.2,425.3l-37.006-11.993-11.158,38.755a22.479,22.479,0,0,0,9.537,25.088l92.362,58.417a21.223,21.223,0,0,0,.114,2.175,22.186,22.186,0,0,0,26.934,19.249,21.572,21.572,0,0,0,2.614-.755,22.252,22.252,0,0,0,14.686-20.755Z"
            transform="translate(384.835 154.956)"
            fill="#ffb8b8"
          />
          <path
            d="M116.389,226.141c-49,0-88.717,1.944-88.717-1.226,0-2.908,33.346-24.262,76.619-27.819V54.436H25.206A25.226,25.226,0,0,1,0,29.235V25.2A25.235,25.235,0,0,1,25.206,0h96.8c0,2.78,99.763,5.039,99.763,5.039a25.811,25.811,0,0,1,4.258,4.03A25.023,25.023,0,0,1,231.876,25.2v4.034a25.207,25.207,0,0,1-25.2,25.2H130.5V197.275c42.292,4.039,74.6,24.777,74.6,27.64,0,1.424-8.012,1.815-21.278,1.815C167.556,226.73,143.382,226.141,116.389,226.141Z"
            transform="translate(636.255 765.08)"
            fill={theme.secondaryText}
          />
          <path
            d="M474.05,746.892l49.281-110.51a40.5,40.5,0,0,0-17.781-51.989L398.658,527.074l-48.777-4.149-44.994-4.09-.324.549c-.415.7-10.089,17.41-3.55,35.733,4.96,13.9,17.862,24.753,38.348,32.265,47.816,17.533,103.052,32.517,124.581,38.145a6.959,6.959,0,0,1,4.458,3.548,7.054,7.054,0,0,1,.4,5.643L423.013,737.581a9.073,9.073,0,0,0,7.681,12.157l34.21,2.491q.436.041.867.041a9.067,9.067,0,0,0,8.279-5.378Z"
            transform="translate(380.621 180.465)"
            fill={theme.dark}
          />
          <path
            d="M457.473,751.657l49.281-110.51a40.5,40.5,0,0,0-17.781-51.989L382.081,531.839,333.3,527.69l-35.241-3.057,0-.484c-.415.7-10.089,17.411-3.55,35.733,4.96,13.9,7.781,24.753,28.266,32.265,47.816,17.533,103.052,32.517,124.581,38.145a6.958,6.958,0,0,1,4.458,3.548,7.054,7.054,0,0,1,.4,5.643L406.436,742.345a9.073,9.073,0,0,0,7.681,12.157l34.21,2.491q.436.041.867.041a9.067,9.067,0,0,0,8.279-5.378Z"
            transform="translate(379.051 181.75)"
            fill={theme.dark}
          />
          <path
            d="M368.349,559.326c2.363-1.672,36.294,16.13,42.343,2.016-28.228-70.571-8.776-101.045-26.067-141.514a50.391,50.391,0,0,0-33.4-28.591l-44.862-2.264-.232.112a52.435,52.435,0,0,0-28.671,55.627c.16,44.043,26.511,77.634,17.3,109.579a10.327,10.327,0,0,0,.976,8.032,9.848,9.848,0,0,0,6.282,4.656l59.236-7.9a10.009,10.009,0,0,0,8.1-1.567Z"
            transform="translate(375.304 149.073)"
            fill={theme.secondaryText}
          />
          <path
            d="M517.835,436.674l5.679,33.721a2.076,2.076,0,0,1-.12,1.116L478.84,582.836a2.076,2.076,0,0,1-4-.684l-1.887-44.736a2.076,2.076,0,0,1,.151-.869l40.762-100.31a2.076,2.076,0,0,1,3.97.437Z"
            transform="translate(422.731 160.185)"
            fill={theme.text}
          />
          <path
            d="M300.76,293.823l5.4,28.97L266.618,424.38,261.485,391.7Z"
            transform="translate(636.653 305.624)"
            fill={theme.imageHighlight}
          />
          <path
            d="M367.253,564.65c.973,3.8,128.693,7.908,130.018,6.759a26.913,26.913,0,0,0,3.072-4.753c1.338-2.39,2.578-4.788,2.578-4.788l-2.1-40.393L375.008,508.031s-5.566,33.708-7.314,49.194A37.2,37.2,0,0,0,367.253,564.65Z"
            transform="translate(397.173 177.853)"
            fill={theme.text}
          />
          <path
            d="M258.945,378.438l.011,34.8-55.647-3.956,2.462-34.624Z"
            transform="translate(622.59 325.164)"
            opacity="0.1"
            style={{ isolation: "isolate" }}
          />
          <path
            d="M196.181,383l.337-.042-2.628,14.794-30.915-2.2,1.055-14.84Z"
            transform="translate(612.84 326.629)"
            opacity="0.1"
            style={{ isolation: "isolate" }}
          />
          <path
            d="M367.253,555.073c.973,3.8,128.693,7.908,130.018,6.759a26.911,26.911,0,0,0,3.072-4.753l-132.649-9.432A37.2,37.2,0,0,0,367.253,555.073Z"
            transform="translate(397.173 187.43)"
            opacity="0.1"
            style={{ isolation: "isolate" }}
          />
          <path
            d="M330.2,517.2l107.738,20.106a21.2,21.2,0,0,0,.911,1.979,22.235,22.235,0,0,0,14.269,11.141,22.179,22.179,0,1,0-5.062-41.127,21.31,21.31,0,0,0-2.508,1.579l-93.578-31.967-4.79-24.126-38.816,2.568,4.022,40.443A22.063,22.063,0,0,0,330.2,517.2Z"
            transform="translate(382.945 164.983)"
            fill="#ffb8b8"
          />
          <path
            d="M307.407,485.288l56.4-18.538-13.157-37.777a22.519,22.519,0,0,0-24.968-14.806h0a22.519,22.519,0,0,0-18.815,22.461Z"
            transform="translate(382.584 155.089)"
            fill={theme.secondaryText}
          />
          <path
            d="M687.784,755.885h-473.1a1.242,1.242,0,1,1,0-2.483h473.1a1.242,1.242,0,1,1,0,2.483Z"
            transform="translate(360 237.167)"
            fill={theme.secondaryText}
          />
          <path
            d="M76.6,13.578c-3.431.2-6.779-.954-10.186-1.4C54.225,10.559,41.549,19.4,38.857,31.4a14.75,14.75,0,0,1-1.409,4.592c-1.876,3.062-6.147,3.642-9.666,2.942s-6.864-2.352-10.445-2.54C11.8,36.1,6.484,39.51,3.534,44.2a26.493,26.493,0,0,0-3.387,16L2.8,57.419A13.482,13.482,0,0,1,4,64.748a8.5,8.5,0,0,0,8.054-2.061c2.341-.249.574,4.343,2.313,5.927a4.022,4.022,0,0,0,2.83.53c4.979-.048,9.008,3.76,12.93,6.827A54.947,54.947,0,0,0,53.337,86.555c5.623,1.1,11.6,1.273,16.934-.821a36.171,36.171,0,0,0,11.435-8.111c8.348-8.027,15.741-17.459,19.213-28.507a47.99,47.99,0,0,0,.23-27.828C99.748,16.564,95.533.39,89.358.013,81.6-.473,86.255,13,76.6,13.578Z"
            transform="translate(774.566 485.494) rotate(154)"
            fill={theme.dark}
          />
          <path
            d="M415.968,626.548H474.3a33.642,33.642,0,0,0,14.493-3.3l10.754-5.168a6.458,6.458,0,0,0-1.075-12.044L476.288,599.9,439.1,581.013a49.858,49.858,0,0,1-2.744,8.433c-3.892,4.46-7.891,6.514-11.883,6.108-6.965-.706-11.6-8.749-11.642-8.831l-.034-.062-.071.008a4.62,4.62,0,0,0-3.585,1.955c-1.59,2.4-.62,6.086-.46,6.643-1.9,1.861-2.761,12.26-2.823,13.1-2.752,2.916-4.059,5.72-3.893,8.333a8.972,8.972,0,0,0,3.763,6.306,16.291,16.291,0,0,0,10.237,3.545Z"
            transform="translate(379.666 364.637)"
            fill={theme.dark}
          />
        </g>
      </svg>
    );
  }
}
